import { getWWRedirectUrl, isTestUser } from "utils/helper";
import { useEffect, useState, useCallback, ReactElement } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { useOktaAuth } from "@okta/okta-react";
import { trackFormError } from "utils/analytics/trackEvent";
interface IAuthModelProps {
  children: ReactElement;
}

type AuthResponse = {
  prospect_id: string;
  canonical_id: string;
};

const AuthModel = ({ children }: IAuthModelProps) => {
  const { authState } = useOktaAuth();
  const searchParams = useParams();
  const memberId = useSearchParams()[0].get("member_id") || "";

  const getAuthResponse = useCallback(async () => {
    const urlString = `/auth?company_uuid=${searchParams.companyUuid}`;
    const url = getWWRedirectUrl(urlString);
    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authState?.accessToken?.accessToken,
        },
      });
      const result = (await response.json()) as AuthResponse;
      localStorage.setItem("memberUuid", memberId);

      if (!result?.prospect_id) {
        trackFormError(
          Error("Auth did not return prospect id"),
          "no prospect id"
        );
        setIsLoading(false);
        return;
      }
      // set uuid from the response to local storage
      localStorage.setItem("uuid", result?.prospect_id);
      // set company id to local storage
      localStorage.setItem("companyId", searchParams?.companyUuid || "");
      // At some point company id will be deprecated in favor of canonical id
      localStorage.setItem("canonicalId", result?.canonical_id);
      setIsUserLoggedIn(true);
      setIsLoading(false);
    } catch (error: any) {
      trackFormError(error, "user not logged in");
      setIsLoading(false);
    }
  }, [searchParams, memberId, authState?.accessToken?.accessToken]);

  useEffect(() => {
    if (authState?.isAuthenticated || isTestUser) {
      getAuthResponse();
    }
  }, [getAuthResponse, authState]);

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <Loader />}
      {isUserLoggedIn && children}
      {!isUserLoggedIn && !isLoading && <ErrorPage />}
    </>
  );
};
export default AuthModel;
